import { getIsViewModeSelected } from 'owa-command-ribbon-store';
import type {
    MailRibbonGroup,
    TabScalingAndLayoutConfig,
} from 'owa-mail-ribbon-store-shared-types';
import { MailRibbonTabId, RibbonControlId, RibbonGroupId } from 'owa-ribbon-ids';
import { CommandingViewMode } from 'owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions';
import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import { LabelPreferenceId } from 'owa-mail-ribbon-store-shared-types';

/**
 * Updates the local store's current selected tab given the parameters.
 */
export default mutatorAction(
    'updateMailRibbonConfiguration',
    (
        layoutOfRibbbonControls: MailRibbonGroup[],
        controlsInOverflow: RibbonControlId[],
        removedDefaultGroups: RibbonGroupId[],
        staticGroupIdOrdering: RibbonGroupId[],
        showLabelsPreference: LabelPreferenceId
    ) => {
        let ribbonViewConfig;
        let tab: TabScalingAndLayoutConfig | undefined;
        if (getIsViewModeSelected(CommandingViewMode.CommandBar)) {
            ribbonViewConfig = getStore().toolbar;
        } else {
            ribbonViewConfig = getStore().singleline;
        }

        switch (getStore().selectedTab) {
            case MailRibbonTabId.Tab_Home:
                tab = ribbonViewConfig.homeTab;
                break;
            case MailRibbonTabId.Tab_View:
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2339 (40,40): Property 'viewTab' does not exist on type '{ homeTab: TabScalingAndLayoutConfig; messageTab: TabScalingAndLayoutConfig; }'.
                // @ts-expect-error
                tab = ribbonViewConfig.viewTab;
                break;
            case MailRibbonTabId.Tab_Message:
                tab = ribbonViewConfig.messageTab;
                break;
            case MailRibbonTabId.Tab_M3Message:
                tab = getStore().singleline.messageTabM3;
                break;
            case MailRibbonTabId.Tab_Insert:
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2339 (49,40): Property 'insertTab' does not exist on type '{ homeTab: TabScalingAndLayoutConfig; messageTab: TabScalingAndLayoutConfig; }'.
                // @ts-expect-error
                tab = ribbonViewConfig.insertTab;
                break;
            case MailRibbonTabId.Tab_Format:
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2339 (55,40): Property 'formatTab' does not exist on type '{ homeTab: TabScalingAndLayoutConfig; messageTab: TabScalingAndLayoutConfig; }'.
                // @ts-expect-error
                tab = ribbonViewConfig.formatTab;
                break;
            case MailRibbonTabId.Tab_Notes:
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2339 (61,40): Property 'notesTab' does not exist on type '{ homeTab: TabScalingAndLayoutConfig; messageTab: TabScalingAndLayoutConfig; }'.
                // @ts-expect-error
                tab = ribbonViewConfig.notesTab;
                break;
            case MailRibbonTabId.Tab_Read:
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2339 (61,40): Property 'notesTab' does not exist on type '{ homeTab: TabScalingAndLayoutConfig; messageTab: TabScalingAndLayoutConfig; }'.
                // @ts-expect-error
                tab = ribbonViewConfig.readTab;
                break;
            case MailRibbonTabId.Tab_ReadOnly_Toolbar:
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2339 (61,40): Property 'notesTab' does not exist on type '{ homeTab: TabScalingAndLayoutConfig; messageTab: TabScalingAndLayoutConfig; }'.
                // @ts-expect-error
                tab = ribbonViewConfig.readonlyTab;
                break;
            case MailRibbonTabId.Tab_Options:
                tab = getStore().singleline.optionsTab;
                break;
            default:
                throw new Error(
                    'Attempting to retrive information from a tab that is not accounted for in the switch case within updateMailRibbonConfigurationMutator.ts'
                );
        }

        if (tab != undefined) {
            tab.layout = layoutOfRibbbonControls;
            tab.controlsInOverflow = controlsInOverflow;
            tab.removedDefaultGroups = removedDefaultGroups;
            tab.staticGroupIdOrdering = staticGroupIdOrdering;
            tab.showLabelsPreference = showLabelsPreference;
        }
    }
);
